import script from "./InvoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceModal.vue?vue&type=style&index=0&id=3567b81e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3567b81e"]])

export default __exports__